import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { MainContext } from "../utils/MainContext";
import closeModal from "../assets/images/icons/close-modal.svg";

const CustomModal = () => {
    useTranslation();
    const { customModalContent, closeAndClearCustomModal } =
        useContext(MainContext);

    return (
        <div
            className={
                customModalContent?.isOpen ? "customModal active" : "customModal"
            }
        >
            <div className="overlay" onClick={() => closeAndClearCustomModal()}></div>
            <div className="customModalBox">
                <div className="closeModal" onClick={() => closeAndClearCustomModal()}>
                    <img src={closeModal} alt="close-icon" />
                    {/* <span>{t("editBoxName.close")}</span> */}
                </div>
                {customModalContent?.content?.title && (
                    <h2 className="modalTitle">{customModalContent?.content?.title}</h2>
                )}
                <div className="content">
                    {customModalContent?.content?.message && (
                        <p className="message">{customModalContent?.content?.message}</p>
                    )}
                    {customModalContent?.content?.customComponent}
                </div>
            </div>
        </div>
    );
};

export default CustomModal;
